import { FormControl, FormGroup, FormLabel, TextField } from "@mui/material";
import { RetailerVendorMailSettings } from "../../../api";

export interface RetailerVendorMailSettingsControlProps {
  settings?: RetailerVendorMailSettings;
  onChange: (settings: Partial<RetailerVendorMailSettings>) => void;
}

export const RetailerVendorMailSettingsControl = (props: RetailerVendorMailSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">Mail settings</FormLabel>
      <FormGroup>
        <TextField label="From email" required variant="standard" value={settings?.fromEmail  ?? ""} onChange={(e) => onChange({ fromEmail: e.target.value })} />
        <TextField label="From name" variant="standard" value={settings?.fromName  ?? ""} onChange={(e) => onChange({ fromName: e.target.value })} />
        <TextField label="To email" required variant="standard" value={settings?.toEmail  ?? ""} onChange={(e) => onChange({ toEmail: e.target.value })} />
        <TextField label="Subject" required variant="standard" value={settings?.subject  ?? ""} onChange={(e) => onChange({ subject: e.target.value })} />
        <TextField label="Text" variant="standard" value={settings?.text  ?? ""} onChange={(e) => onChange({ text: e.target.value })} />
        <TextField label="Html" variant="standard" value={settings?.html  ?? ""} onChange={(e) => onChange({ html: e.target.value })} />
      </FormGroup>
    </FormControl>
  );
};
